'use strict';

import * as Onyx from '../../lib/onyx.min.js';

export default class SceneGameover extends Onyx.Scene {
    constructor(){
        super({
            template: '@@import routes/gameover/index.html'
        });
    }

    onload(params){
        super.onload(params);

        //TODO: Make this DRY
        
        // Populate table
        let tableEl = document.createElement("table");

        for(let i in params.ranking){
            let player = params.ranking[i];
            let row = document.createElement("tr");

            row.innerHTML = `
                <td>${(i * 1) + 1}</td>
                <td>${player.name}</td>
            `;

            if(player === params.player) row.classList.add("player");
            row.style.animationDelay = (i / 12) + "s";
            row.style.animationDuration = "0.25s";
            row.classList.add("animated");
            row.classList.add("fadeInLeft");

            tableEl.appendChild(row);
        }

		document.getElementById("score").appendChild(tableEl);

        // game.sfx['timesUp'].play();
    }

    // @Onyx.handles('click') //, {elementId: 'tryagain'}
    tryagain(){ 
        router.navigate("game");
    }

    update(...args){
        super.update(...args);
    }

    onunload(){
        super.onunload();

        game.music['game'].stop();
    }
}